import { render, staticRenderFns } from "./DetailContact.vue?vue&type=template&id=5bc6866a&scoped=true&"
import script from "./DetailContact.vue?vue&type=script&lang=js&"
export * from "./DetailContact.vue?vue&type=script&lang=js&"
import style0 from "./DetailContact.vue?vue&type=style&index=0&id=5bc6866a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6866a",
  null
  
)

export default component.exports